import { Component, Inject, OnInit } from "@angular/core";
import { ActivityLogService } from '@/angular-blocworx/components/activity-log/activity-log.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'activity-log',
    templateUrl: 'angular-blocworx/components/activity-log/activity-log.html',
    styleUrls: ['angular-blocworx/components/activity-log/activity-log.scss'],
})
export class ActivityLogComponent implements OnInit {
    logs$!: Observable<any[]>;
    meta: any = {};

    currentPage: number = 1;
    itemsPerPage: number = 10;
    availablePageSizes: number[] = [5, 10, 20, 50, 100];

    startDate: string = '';
    endDate: string = '';

    constructor(@Inject(ActivityLogService) private activityLogService: ActivityLogService) {}

    ngOnInit() {
        this.loadLogs();
    }

    /**
     * Loads activity logs for the current page, with optional date filters.
     */
    loadLogs(): void {
        this.activityLogService.getLogs(
            this.currentPage,
            this.itemsPerPage,
            this.startDate,
            this.endDate
        ).subscribe({
            next: (res) => {
                this.logs$ = new Observable(observer => observer.next(res.data));
                this.meta = res.meta;
            },
            error: (err) => {
                console.error('Error fetching activity logs:', err);
            }
        });
    }

    /**
     * Called when the 'Apply Filters' button is clicked.
     * Resets page to 1 and reloads logs with current filter settings.
     */
    applyFilters(): void {
        this.currentPage = 1;
        this.loadLogs();
    }

    /**
     * Handles change in items per page dropdown.
     * Resets page to 1 and reloads logs with new page size.
     */
    onItemsPerPageChange(): void {
        this.currentPage = 1;
        this.loadLogs();
    }

    /**
     * Resets all filters (dates and page) and reloads logs.
     */
    resetFilters(): void {
        this.startDate = '';
        this.endDate = '';
        this.currentPage = 1;
        this.itemsPerPage = 10;
        this.loadLogs();
    }

    prevPage(): void {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.loadLogs();
        }
    }

    nextPage(): void {
        if (this.currentPage < this.meta.last_page) {
            this.currentPage++;
            this.loadLogs();
        }
    }

    trackByLogId(index: number, log: any): string {
        return log.id;
    }
}
